module.exports = __webpack_public_path__ + "static/media/manchester.0836f1d3.png";